import { Injector, ModuleWithProviders } from '@angular/core';
import { ScreenService } from '.';
import { defaultConfig, SCREEN_SERVICE_CONFIG_DYNAMIC_PROVIDER, SCREEN_SERVICE_CONFIG_PROVIDER } from './interfaces';
import * as i0 from "@angular/core";
export function configFactory(injector) {
  const providedConfig = injector.get(SCREEN_SERVICE_CONFIG_DYNAMIC_PROVIDER);
  return {
    ...defaultConfig,
    ...providedConfig
  };
}
export let UiScreenServiceModule = /*#__PURE__*/(() => {
  class UiScreenServiceModule {
    static forRoot(config) {
      return {
        ngModule: UiScreenServiceModule,
        providers: [{
          provide: SCREEN_SERVICE_CONFIG_DYNAMIC_PROVIDER,
          // you can also use InjectionToken
          useValue: config
        }, {
          provide: SCREEN_SERVICE_CONFIG_PROVIDER,
          useFactory: configFactory,
          deps: [Injector, SCREEN_SERVICE_CONFIG_DYNAMIC_PROVIDER]
        }, {
          provide: ScreenService,
          useClass: ScreenService
        }]
      };
    }
    static {
      this.ɵfac = function UiScreenServiceModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || UiScreenServiceModule)();
      };
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: UiScreenServiceModule
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({});
    }
  }
  return UiScreenServiceModule;
})();